export default __webpack_public_path__ + "static/media/16.blur.4e186dca.JPG";